import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { BasketSummaryDetailsStyled } from '../BasketSummaryDetailsStyled';
import { rem } from 'polished';

export const BasketSummaryDetailsDS = styled(BasketSummaryDetailsStyled)`
    padding: ${rem(22)} ${rem(16)};
    .title {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        background: ${({ theme }) => theme.colors.white};
    }

    .priceSection {
        border-color: ${({ theme }) => theme.colors.grey16};
    }

    .storePrice {
        border-color: ${({ theme }) => theme.colors.grey16};

        &_value {
            .storePrice_title {
                max-width: ${rem('215px')};
            }
        }
        &_link {
            font-size: ${({ theme }) => theme.fontSizes.h5};

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .promoCodeResult,
    .dealerDiscountResult {
        border-color: ${({ theme }) => theme.colors.grey16};

        .price {
            width: 32%;
        }
    }

    .totalPrice {
        border-color: ${({ theme }) => theme.colors.grey16};

        &_cashPrice,
        &_monthlyPrice {
            font-size: ${({ theme }) => theme.fontSizes.h4};

            &.isCash {
                font-size: ${({ theme }) => theme.fontSizes.h4};
            }
        }

        &_label {
            font-size: ${({ theme }) => theme.fontSizes.h6};
        }
    }

    .pxSection {
        background: ${({ theme }) => theme.colors.grey4};
        border-radius: ${rem(8)};
        padding: ${rem(18)} ${rem(16)};
    }

    .promoCodeSection {
        padding: ${rem(20)} 0;

        &.isClose {
            svg {
                transform: rotate(180deg);
            }
        }

        .promoCodeSection_title {
            display: flex;
            flex-direction: row-reverse;
            font-size: ${({ theme }) => theme.fontSizes.h5};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            color: ${({ theme }) => theme.colors.black1};
            text-align: left;
            svg {
                path {
                    stroke: none;
                    fill: ${({ theme }) => theme.colors.black1};
                }
            }
        }

        .promoCodeSectionWrapper {
            .promoCode__input {
                border-color: ${({ theme }) => theme.colors.grey5};
                border-radius: ${rem(3)};
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }

            div {
                background: unset;

                button {
                    border-radius: ${rem(24)};
                    color: ${({ theme }) => theme.colors.white};
                    background: ${({ theme }) => theme.colors.black1};
                    border-color: ${({ theme }) => theme.colors.black1};
                    font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                    text-transform: unset;
                    min-height: ${rem(48)};
                    margin-top: ${rem(10)};

                    @media (min-width: ${breakpoints.sm}px) {
                        min-height: auto;
                        margin-top: 0;
                    }

                    &:hover:enabled {
                        background: ${({ theme }) => theme.colors.primary};
                        border-color: ${({ theme }) => theme.colors.primary};
                    }

                    &:disabled {
                        color: ${({ theme }) => theme.colors.black1};
                        background: ${({ theme }) => theme.colors.white};
                    }
                }
            }
        }
    }

    .ecoBonusWrapper {
        button {
            background: none;
            cursor: pointer;

            svg {
                g {
                    line,
                    circle {
                        stroke: ${({ theme }) => theme.colors.black1};
                    }
                }
            }
        }
    }

    .infoIcon {
        svg {
            g {
                circle,
                line {
                    stroke: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }
`;
